import * as uiConsts from "./consts"
import * as mobileNavHelper from "./mobile-nav-helper"

class MobileNavigation {
  constructor() {
    this.navigationNode = document.getElementsByClassName("main-navigation")[0]
    this.hamburger = document.querySelector(".btn-toggleMobile")

    window.matchMedia("(min-width: 767px)").addListener(e => {
      if (e.matches) {
        this.closeNav()
        this.hamburger.classList.remove("open")
      }
    })

    this.initMobile()
  }

  initMobile() {
    if (this.hamburger === null) return;
    this.hamburger.addEventListener("click", event => {
      this.hamburger.classList.toggle("open")
      if (this.hamburger.classList.contains("open")) this.openNav()
      else this.closeNav()
    })

    mobileNavHelper.getMobileNav()
  }

  openNav() {
    document.getElementById("nav-mobile").style.width = "100%"
    uiConsts.NAV_MOBILE.style.display = "block"
  }

  closeNav() {
    document.getElementById("nav-mobile").style.width = "0"
    uiConsts.NAV_MOBILE.style.display = "none"
  }
}

export default MobileNavigation
